<div class="component-main-container">
  <app-page-header parentTitle="{{ 'logs.logs-parent-label' | translate }}"
    pageTitle="{{ 'logs.form-filter-installation' | translate }}">
  </app-page-header>

  <!--Corpo do componente-->
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-logs-form></app-logs-form>

        <div class="form-fields-box" [ngClass]="!filterBox ? 'closed' : ''" [formGroup]="filterLogsForm">
          <h2 (click)="filterBoxOpen()">
            {{ "logs.form-filter-label" | translate }}
          </h2>
          <hr [ngClass]="!filterBox ? 'hr-open' : ''" />

          <!-- Campo de filtro por Operação. -->
          <div class="form-step">
            <div class="circle-number"> 1 </div>
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>{{ "logs.form-operation" | translate }}</mat-label>
              <mat-select formControlName="operation" name="operation">
                <mat-option value="">{{
                  "logs.form-filter-null" | translate
                  }}</mat-option>
                <mat-option value="CREATE">{{
                  "logs.form-create-label" | translate
                  }}</mat-option>
                <mat-option value="UPDATE">{{
                  "logs.form-update-label" | translate
                  }}</mat-option>
                <mat-option value="DELETE">{{
                  "logs.form-delete-label" | translate
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Campo de filtro por data. -->
          <div class="form-step">
            <div class="circle-number"> 2 </div>
            <div class="form-step">
              <div class="date-picker-input">
                <p-datepicker inputId="calendar-24h" selectionMode="range" formControlName="logsDateTime"
                  appendTo="body" placeholder="{{ 'logs.form-date' | translate }}" showIcon iconDisplay="input"
                  dateFormat="dd/mm/yy">
                </p-datepicker>
              </div>
            </div>
          </div>

          <!-- Input para buscar a instalação. -->
          <div class="form-step">
            <div class="circle-number"> 3 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{ "logs.form-select-reference" | translate }}</mat-label>
              <input matInput formControlName="reference" #referenceLog [(ngModel)]="reference"
                formControlName="reference">
              @if (!filterInstallationLoading) {
              <mat-icon class="component-search-icon" svgIcon="bx-search"
                (click)="searchInstallationLogsByReference(referenceLog.value)"></mat-icon>
              }

              <!-- Loading. -->
              @if (filterInstallationLoading) {
              <mat-spinner class="mat-spinner" [diameter]="30"></mat-spinner>
              }
            </mat-form-field>
          </div>

          <!-- Exibe um alerta caso o usuário digite algum conteúdo no input e não filtre a instalação. -->
          @if (reference && !inputReferenceController ) {
          <div class="alert alert-danger" role="alert">
            {{'logs.alert-search-installation' | translate}}
          </div>
          }

          <!-- Lista as instalações filtradas. -->
          @if (installationList.length > 0) {
          <div class=" form-step">
            <div class="circle-number-ready"> 3.1 </div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{"logs.form-select-installation" | translate}}
              </mat-label>
              <mat-select (selectionChange)="onSelectInstallation($event)">
                @for (installation of installationList; track installation) {
                <mat-option apperance="outline" [value]="installation.id">
                  {{installation.reference}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <!-- Exibe um alerta caso o usuário filtre todas as instalações e não selecione nenhuma opção. -->
          @if (!selectedInstallationController && inputReferenceController) {
          <div class="alert alert-danger" role="alert">
            {{'logs.alert-select-installation' | translate}}
          </div>
          }

          <!-- Campo de filtro por usuário. -->
          <div class="form-step">
            <div class="circle-number"> 4</div>
            <mat-form-field appearance="outline">
              <mat-label>{{ "logs.form-filter-user" | translate }}</mat-label>
              <input matInput formControlName="username" />
            </mat-form-field>
          </div>

          <!-- Botão de filtro. -->
          @if (!filterLoading) {
          <button
            [disabled]="reference && !inputReferenceController || filterInstallationLoading || !selectedInstallationController && inputReferenceController"
            title="{{ 'logs.form-filter-button' | translate }}" class="btn btn-success"
            (click)="filterInstallationLogs(null)">
            {{ "logs.form-filter-button" | translate }}
          </button>
          }
          <!-- Loading. -->
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!-- Sessão tabela. -->
    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [loadingData$]="fileLoading" [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')"></app-table-header>
      @if (filterLoading) {
      <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
      }
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" [rows]="pageSize" [totalRecords]="length" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true"
          styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="username">{{ "logs.form-filter-user" | translate }}</th>
              <th pSortableColumn="operation">{{ "logs.form-operation" | translate }}</th>
              <th pSortableColumn="logDatetime"> {{ "logs.form-logDatetime" | translate }}</th>
              <th pSortableColumn="equipmentSerialNumber"> {{ "logs.form-serialNumber" | translate
                }}</th>
              <th pSortableColumn="previousEquipmentSerialNumber">{{
                "logs.form-previousSerialNumber" | translate }}
              </th>
              <th pSortableColumn="reference">{{ "logs.form-reference" | translate }}</th>
              <th pSortableColumn="siteReference">{{ "logs.form-siteReference" | translate }}</th>
              <th pSortableColumn="gatewayReference">{{ "logs.form-gatewayReference" | translate }}
              </th>
              <th pSortableColumn="isActive">{{ "logs.form-isActive" | translate }}</th>
              <th pSortableColumn="lampModel">{{ "logs.form-lampModel" | translate }}</th>
              <th pSortableColumn="divisionReference">{{ "logs.form-divisionReference" | translate
                }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{ row.username }}</td>
              <td on-mouseover="row.view = true" on-mouseleave="row.view = false">
                <div class="view" [ngClass]="row.view === true ? '' : 'hover'">
                  {{ getTranslationKey(row) | translate }}
                </div>
                <button (click)="openModalInfoOperations(row)" [ngClass]="row.view === true ? 'hover' : ' '"
                  class="btn btn-success view">
                  <mat-icon class="component-svg-icon" svgIcon="bx-show-white"></mat-icon>
                </button>
              </td>
              <td>{{ formatDate(row.logDatetime)}}</td>
              <td>{{ row.equipmentSerialNumber }}</td>
              <td>{{ row.previousEquipmentSerialNumber }}</td>
              <td>{{row.reference}}</td>
              <td>{{row.siteReference}}</td>
              <td>{{row.gatewayReference}}</td>
              <td>{{ getTranslationKeyIsActive(row) | translate }}</td>
              <td>{{ row.lampModel }}</td>
              <td>{{row.divisionReference}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>
</div>

<!-- Abre o modal que exibe as informações alteradas da coluna de operações -->
<ng-template #dialogTemplate let-dialogRef="dialogRef">
  <div class="dialogRef">
    <h2 mat-dialog-title>{{'logs.title-info-operations' | translate}}</h2>
    <mat-divider></mat-divider>
    <mat-dialog-content class="mat-typography">
      <mat-list>
        <ul>
          <!-- Exibe informações para equipamento atualizado -->
          @if (updatedEquipment) {
          <li>
            <mat-list-item> {{'logs.the-equipment' | translate}}
              <b>{{previousEquipmentSerialNumber}}</b>
              {{'logs.info-updated-equipment' | translate}} <b>{{equipmentSerialNumber}}.</b>
            </mat-list-item>
            <mat-divider></mat-divider>
          </li>
          }

          <!-- Exibe informações para equipamento adicionado -->
          @if (addEquipment) {
          <li>
            <mat-list-item>
              {{'logs.the-equipment' | translate}} <b>{{equipmentSerialNumber}}</b>
              {{'logs.info-add-equipment' | translate}}
            </mat-list-item>
            <mat-divider></mat-divider>
          </li>
          }

          <!-- Exibe informações para equipamento removido -->
          @if (removedEquipment) {
          <li>
            <mat-list-item> {{'logs.the-equipment' | translate}}
              <b>{{previousEquipmentSerialNumber}}</b>
              {{'logs.info-removed-equipment' | translate}}
            </mat-list-item>
            <mat-divider></mat-divider>
          </li>
          }

          <!-- Exibe informações para instalação atualizada -->
          @if (updatedInstallationReference) {
          <li>
            <mat-list-item>{{'logs.the-installation' | translate}}
              <b>{{previousReferenceInstallation}}</b>
              {{'logs.info-updated-installation' | translate}} <b>{{referenceInstallation}}</b>.
            </mat-list-item>
            <mat-divider></mat-divider>
          </li>
          }

          <!-- Exibe informações para instalação inativada -->
          @if (isInactivatedInstallation) {
          <li>
            <mat-list-item>
              {{'logs.info-installation' | translate}} <b>{{referenceInstallation}}</b>
              {{'logs.info-inactivate-installation' | translate}}
            </mat-list-item>
            <mat-divider></mat-divider>
          </li>
          }

          <!-- Exibe informação para quando não há nenhuma alteração relacionada aos equipamentos ou instalações -->
          @if (updatedInfoCount <= 0) { <li>
            <mat-list-item>
              {{'logs.info-no-changes' | translate}}
            </mat-list-item>
            </li>
            }
        </ul>
      </mat-list>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-flat-button color="success" mat-dialog-close>OK</button>
    </mat-dialog-actions>
  </div>
</ng-template>